<template lang="html">
  <div class="about">
    <!-- <img src="static/imgs/logotip.jpg" alt=""> -->
    <h2>O NAMA</h2>
    <div class="wrapper">
        <img src="static/imgs/onama.png" alt="">
        <div class="text">
              Preduzeće Virginia d.o.o. osnovao je gospodin Ljubomir Dragojević, dipl. ing. polj. 1999. godine u Beogradu sa osnovnom delatnošću trgovine i distribucije najkvalitetnijih poljoprivrednih proizvoda i repromaterijala. Konstantnim proširivanjem našeg obima delatnosti izrasli smo u moderno preduzeće, usko specijalizovano za više segmenata u oblasti savremene poljoprivredne proizvodnje. Pozicioniranju našeg preduzeća doprinelo je kontinuirano ispitivanje novih proizvoda i tehnologija na našem oglednom polju, čime smo nakon precizne selekcije renomiranih dobavljača i njihovih proizvoda za Vas odabrali najkvalitetnije repromaterijale firmi Pindstrup (supstrati), Nirit Seeds (semena), Everris i Adob (đubriva), Biobest (bumbari i predatori), Politiv (plasteničke i malč folije), Mottes... Misija preduzeća Virginia je da, pružajući vrhunski kvalitet proizvoda i usluga, proizvođačima obezbedi visok stepen sigurnosti i stabilnosti u privređivanju. Naša vizija je da budemo sinonim za preduzeće koje stalno postavlja više standarde u oblasti poljoprivredne proizvodnje, unapređujući je kreiranjem i predviđanjem savremenih tržišnih trendova. Težimo vodećoj poziciji u zemlji i značajnoj u regionu, stručno ispunjavajući svoje odgovornosti, što smatramo najvažnijim izazovom liderstva. U obavljanju svoje delatnosti u potpunosti smo fokusirani na potrebe Vaše proizvodnje. Upravo nam je ovakav tržišni pristup omogućio da smo danas jedna od retkih srpskih firmi koja osim u Srbiji, uspešno posluje i u regionu. Dozvolite da naša stručnost i dokazano iskustvo budu Vaš pouzdan izbor. Možemo Vam ponuditi idealna rešenja, kao i najstručniji servis za uspešno obavljanje Vaše proizvodnje
        </div>
    </div>

  </div>
</template>

<script>
import {mapGetters, mapActions, mapMutations} from 'vuex';

export default {
  data(){
    return{


    }
  },
  computed:{
    ...mapGetters([

    ]),


  },
  methods:{
    ...mapActions([

    ]),

},

  mounted(){
    document.getElementById('myheader').scrollIntoView();
    window.scroll(0,0);
    // this.checksession(this.getsid)

  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/about.vue